import { PlusOutlined } from '@ant-design/icons';
import { Breadcrumb, Button } from 'antd';
import { AccessControl } from 'components/AccessControl';
import React from 'react';
import { Link } from 'react-router-dom';
import { TableHeaderWrapper } from './style';

function TableHeader({
  breadcrumbs = [],
  onCreate,
  hideAction = false,
  children,
  actionText = 'Создать',
  pageId,
}) {
  return (
    <TableHeaderWrapper
      flexJustify={breadcrumbs.length > 0 ? 'between' : 'end'}
    >
      {breadcrumbs && breadcrumbs.length > 0 ? (
        <Breadcrumb>
          {breadcrumbs.map(({ id, text, link }) => (
            <Breadcrumb.Item key={id}>
              {link ? <Link to={link}>{text}</Link> : text}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      ) : null}

      {children}

      {!hideAction && (
        <AccessControl pageId={pageId} action="create">
          <Button type="primary" icon={<PlusOutlined />} onClick={onCreate}>
            {actionText}
          </Button>
        </AccessControl>
      )}
    </TableHeaderWrapper>
  );
}

export { TableHeader };
